import React, { useEffect, useState } from 'react';
import moment from 'moment';

/**
 * LastRefreshTimer Component
 * @param {Date} lastRefreshAt - The date/time of the last refresh
 */

const LastRefreshTimer = ({ lastRefreshAt }) => {
  const [lastRefresh, setLastRefresh] = useState('--');

  useEffect(() => {
    if (!lastRefreshAt) {
      setLastRefresh('--');
      return;
    }
    const updateLabel = () => {
      const diff = Math.floor((Date.now() - new Date(lastRefreshAt)) / 60000);
      if (diff === 0) setLastRefresh('Just now');
      else if (diff === 1) setLastRefresh('1 min ago');
      else setLastRefresh(`${diff} mins ago`);
    };
    updateLabel(); // Update immediately on mount
    const interval = setInterval(updateLabel, 60000);
    return () => clearInterval(interval);
  }, [lastRefreshAt]);

  return <span>{lastRefresh}</span>;
};

export default LastRefreshTimer;
